import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {IsSavedService} from './services/is-saved.service';

@Injectable({
  providedIn: 'root'
})
export class IsSavedGuard  {

  constructor(public service: IsSavedService) {}

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.service.getIsSaved();
  }
}
